import { render, staticRenderFns } from "./change-mail.vue?vue&type=template&id=4d8afdae&scoped=true&"
import script from "./change-mail.vue?vue&type=script&lang=js&"
export * from "./change-mail.vue?vue&type=script&lang=js&"
import style0 from "./change-mail.vue?vue&type=style&index=0&id=4d8afdae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8afdae",
  null
  
)

export default component.exports